import * as React from 'react';
import { AdminDashboardPageLayout } from '../../containers/AdminDashboardPageLayout';
import { BlogSettings } from '../../containers/blogs/BlogSettings';

export const AdminAccountBlogSettingsPage: React.FC = () => {
	return (
		<AdminDashboardPageLayout>
			<BlogSettings />
		</AdminDashboardPageLayout>
	);
};
